import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgAlertTriangleOutline } from './svg/alert-triangle-outline.svg.js';

const AlertTriangle = (props) => {
    const { title, size = 24, legacyBoundingBox, ...rest } = props;
    let dimensions = size;
    let viewBoxValue = '0 0 24 24';
    if (legacyBoundingBox && size < 24) {
        dimensions = 24;
        if (size === 12) {
            viewBoxValue = '-6 -6 36 36';
        }
        if (size === 16) {
            viewBoxValue = '-4 -4 32 32';
        }
        if (size === 20) {
            viewBoxValue = '-2.5 -2.5 29 29';
        }
    }
    return (jsx(SvgAlertTriangleOutline, { viewBox: viewBoxValue, "aria-label": title, role: "img", ...rest, width: `${dimensions}`, height: `${dimensions}`, "data-pp-icon": "AlertTriangle" }));
};

export { AlertTriangle as default };
//# sourceMappingURL=AlertTriangle.js.map
